import { render } from "./UpdateSharedFS.vue?vue&type=template&id=663ab07e&scoped=true"
import script from "./UpdateSharedFS.vue?vue&type=script&lang=js"
export * from "./UpdateSharedFS.vue?vue&type=script&lang=js"

import "./UpdateSharedFS.vue?vue&type=style&index=0&id=663ab07e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663ab07e"]])

export default __exports__